import { Component, inject } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-promotion',
  standalone: false,

  templateUrl: './promotion.component.html',
  styleUrl: './promotion.component.scss'
})
export class PromotionComponent {

  authServeice = inject(AuthandregistryService);
  promotionId: string | undefined = "";
  promo: any;
  constructor(
    private router: Router
  ) {
    this.promotionId = window.location.href.split('/').pop();
    this.loadData();
  }

  async loadData() {
    if (this.promotionId)
      this.promo = await this.authServeice.promotionCheck(this.promotionId.split('?')[0]);
    console.log('promo', this.promo);


    // RoutingService here
    if (this.promo.skipRegistration && this.promo.skipRegistration === 1) {
      // Skip Registration
      if (this.promo.targetType === 'TRACK') {
        // Routing to Track
        this.router.navigate([`home/new-track-run/${this.promo.targetId}`, this.promo.targetId]);
      }
    }
  }

}
